var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.000000pt",
    height: "25.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#64ffda",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 5106 c-191 -46 -353 -209 -398 -397 -13 -56 -15 -324 -15 -2149 0 -2298 -4 -2148 62 -2274 48 -90 147 -185 238 -228 41 -20 99 -41 128 -47 37 -8 663 -11 2135 -11 2288 0 2141 -4 2269 61 130 66 247 220 277 367 16 75 16 4189 0 4264 -30 147 -147 301 -277 367 -128 65 21 61 -2277 60 -1651 -1 -2101 -3 -2142 -13z m4297 -227 c80 -37 125 -81 162 -157 l33 -67 0 -2095 0 -2095 -26 -55 c-37 -80 -81 -125 -157 -162 l-67 -33 -2095 0 -2095 0 -67 33 c-76 37 -120 82 -157 162 l-26 55 0 2095 0 2095 26 55 c47 99 116 159 218 186 36 10 498 12 2121 11 l2075 -2 55 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553 3614 c-29 -15 -63 -65 -63 -94 0 -7 7 -27 16 -45 32 -68 -24 -65 1054 -65 1078 0 1022 -3 1054 65 9 18 16 38 16 45 0 7 -7 27 -16 45 -32 68 24 65 -1056 65 -863 0 -977 -2 -1005 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553 2654 c-29 -15 -63 -65 -63 -94 0 -7 7 -27 16 -45 32 -68 -24 -65 1054 -65 1078 0 1022 -3 1054 65 9 18 16 38 16 45 0 7 -7 27 -16 45 -32 68 24 65 -1056 65 -863 0 -977 -2 -1005 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553 1694 c-29 -15 -63 -65 -63 -94 0 -7 7 -27 16 -45 32 -68 -24 -65 1054 -65 1078 0 1022 -3 1054 65 9 18 16 38 16 45 0 7 -7 27 -16 45 -32 68 24 65 -1056 65 -863 0 -977 -2 -1005 -16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.29e2837d3870dddb3a10bb05d326c442.svg";
export { ForwardRef as ReactComponent };